var menuUrl = 'https://menu.addigitech.com/';
var menuAjaxUrl = menuUrl + 'app.php';

/************************************************
 *              Some Common Functions            *
 *************************************************/

var menuLoad = {
    script: function (url, callback, value) {
        var script = document.createElement("script")
        script.type = "text/javascript";
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    if (callback != undefined && value != undefined) {
                        callback(value);
                    } else if (callback != undefined) {
                        callback();
                    }
                }
            };
        } else {
            script.onload = function () {
                if (callback != undefined && value != undefined) {
                    callback(value);
                } else if (callback != undefined) {
                    callback();
                }
            };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    },
    style: function (url) {
        var headTag = document.getElementsByTagName("head")[0];
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = url;
        link.media = "all";
        headTag.appendChild(link);
    }
}
/************************************************
 *         Some Common Functions END            *
 *************************************************/

var menuObj = '';
if (typeof jQuery == 'undefined') {
    menuLoad.script('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', initializeMenu, function () {
        if(Shopify.shop != 'drclab.myshopify.com'){
            $ = jQuery.noConflict(true);
        }
        menuObj = new initializeMenu();
    });
} else {
    if(Shopify.shop != 'drclab.myshopify.com'){
            $ = jQuery.noConflict(true);
        }
    menuObj = new initializeMenu();
}

function initializeMenu() {
    var shop = Shopify.shop;
    var s = window.matchMedia("only screen and (max-width: 769px)")
    var device = "desktop";
    if (s.matches) {
        device = "mobile";
    }
    jQuery(function ($) {
        jQuery.ajax({
            url: menuAjaxUrl,
            type: "post",
            dataType: "json",
            data: {shop: shop, action: 'initialize'},
            success: function (response) {
                if (response.result == 'success' && response.html != '') {
                    jQuery('body').append(response.html);
                    if (device == 'mobile') {
                        $('body').css({'margin-bottom': $(".ad-mobile-menu-bar-wrap").height() + 'px'});
                    }
                }
            },
            error: function () {
                //alert('Sorry, Action not Process, Try again.');
            }
        });
    });
}